import axios from "axios";

const API = `${process.env.REACT_APP_API_URL}/subscription`;

const authHeader = () => ({
  "x-business-owner-token": localStorage.getItem("businessOwnerToken") || ""
});

/** Fetches current subscription status for the logged-in business owner. */
export const getSubscriptionStatus = async () => {
  const res = await axios.get(`${API}/status`, { headers: authHeader() });
  return res.data;
};

/** Creates a Razorpay order and returns order + key details. */
export const createOrder = async () => {
  const res = await axios.post(`${API}/order`, {}, { headers: authHeader() });
  return res.data;
};

/** Sends verified Razorpay payment details to the backend for activation. */
export const verifyPayment = async (paymentData) => {
  const res = await axios.post(`${API}/verify`, paymentData, { headers: authHeader() });
  return res.data;
};

/**
 * Loads the Razorpay checkout script dynamically (only once).
 * Returns a promise that resolves when the script is ready.
 */
export const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) { resolve(true); return; }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload  = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

/**
 * Opens the Razorpay checkout popup.
 * @param {object} orderData  Response from createOrder()
 * @param {function} onSuccess Called with {razorpay_order_id, razorpay_payment_id, razorpay_signature}
 * @param {function} onFailure Called when payment is dismissed or fails
 */
export const openRazorpayCheckout = (orderData, onSuccess, onFailure) => {
  const options = {
    key:         orderData.keyId,
    amount:      orderData.amount,
    currency:    orderData.currency,
    name:        "BusinessNearMe",
    description: "Annual Listing Subscription – ₹100/year",
    order_id:    orderData.orderId,
    prefill: {
      contact: orderData.contact,
      email:   orderData.email
    },
    theme: { color: "#1a73e8" },
    handler: onSuccess,
    modal: { ondismiss: onFailure }
  };

  const rzp = new window.Razorpay(options);
  rzp.open();
};
